import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the token from localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const entryAPI = {
  getAll: (params = {}) => api.get('/entries', { params }),
  getById: (id) => api.get(`/entries/${id}`),
  create: (data) => api.post('/entries', data),
  update: (id, data) => api.put(`/entries/${id}`, data),
  delete: (id) => api.delete(`/entries/${id}`),
};

export const exportAPI = {
  csv: (params = {}) => api.get('/export/csv', { params }),
  pdf: (params = {}) => api.get('/export/pdf', { params, responseType: 'blob' }),
};

export const insightsAPI = {
  get: () => api.get('/insights'),
};


export const statsAPI = {
  get: () => api.get('/stats'),
};

export default api;